import Backbone from "backbone";
import SharedDispatcher from "../others/SharedDispatcher";
import Cookies from "js-cookie";

export default Backbone.View.extend({
    /**
      * @class CartCountView
      *
      * @augments Backbone.View
      * @constructs
      *
      * Set initial count and listen to global event.
      * Global event example :
      * SharedDispatcher.trigger("cartcount:update", {count: 0})
    */
    initialize: function () {
      this.listenTo(SharedDispatcher, "cartcount:update", this.update);
      this.cartChangeListener();
      setInterval(this.cartChangeListener.bind(this), 1500);
    },

    /**
     * Listen for number of articles in cart (cookie 'NBART').
     *
     * @returns {void}
     */
    cartChangeListener: function() {
      const count = this.getCookieNumberArticles();
      if (count !== this.count) {
        this.cartRefresh(count);
      }
    },

    /**
     * Update cart count and refresh cart tab.
     *
     * @returns {void}
     */
    cartRefresh: function(count) {
      this.update({ count });
      SharedDispatcher.trigger('headerTabBasketView:refresh');
    },

    /**
     * Get cookie ('NBART') number of articles.
     *
     * @returns {number}
     */
    getCookieNumberArticles: function() {
      return Number(Cookies.get("NBART")) || 0;
    },

    /**
     * Update cart count and render.
     * Return immediately if options or options count not present.
     *
     * @returns {void}
     */
    update: function(options) {
      if (!options || typeof options.count === 'undefined') {
        return
      }
      this.count = Number(options.count);
      this.render();
    },

    /**
     * Propagates changes to the dom.
     *
     * @method
     * @returns {void}
     */
    render: function () {
      if (this.count < 100) {
        this.$el.text(this.count);
      }
      else {
        this.$el.text(this.$el.data('maxlabel'));
      }

      if (this.count > 0) {
        this.$el.removeClass("Header__tabs-cartCount--empty");
      } else {
        this.$el.addClass("Header__tabs-cartCount--empty");
      }
    }
  })
